import React from "react";
import type { HelpCenter } from "../../../types";
import { HelpCenterRow } from "./HelpCenterRow";

interface HelpCentersTableProps {
  helpCenters: HelpCenter[];
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
  formatDate: (dateString: string) => string;
}

export const HelpCentersTable: React.FC<HelpCentersTableProps> = ({
  helpCenters,
  onEdit,
  onDelete,
  formatDate,
}) => {
  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b">
            <th className="text-left py-1.5 px-2 font-medium text-sm text-muted-foreground">
              Title
            </th>
            <th className="text-left py-1.5 px-2 font-medium text-sm text-muted-foreground">
              Slug
            </th>
            <th className="text-left py-1.5 px-2 font-medium text-sm text-muted-foreground">
              Updated
            </th>
            <th className="text-left py-1.5 px-2 font-medium text-sm text-muted-foreground">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {helpCenters.map((helpCenter) => (
            <HelpCenterRow
              key={helpCenter.id}
              helpCenter={helpCenter}
              onEdit={onEdit}
              onDelete={onDelete}
              formatDate={formatDate}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

